import React, { useEffect, useState } from 'react';
import router from 'next/router';
import Layout from '@/layouts/simple';
import { WeeeIcon } from '@/components/common/Icon';
import styles from './index.module.scss';
import { getLoginState } from '@/utils/common/user';
import { getSimpleAccountInfo } from '@/api/customer';

export default function AgreementContent({ data }) {
  const { title, key, descriptionHtml, content, type } = data || {};

  const isLogin = getLoginState();
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    if (isLogin) {
      getSimpleAccountInfo().then(res => {
        if (res.result) {
          setIsAdmin(res?.object?.article_privilege);
        }
      });
    }
  }, [isLogin]);

  return (
    <Layout
      title={title || ''}
      contentClassName={styles.content}
      rightNode={
        <>
          {isAdmin && type == 'legel' && (
            <WeeeIcon
              className={styles.editBtn}
              type="iconpencil"
              onClick={() => {
                router.push(`/admin_article/edit/original?p=${key}`);
              }}
            />
          )}
        </>
      }>
      {(!!descriptionHtml || !!content) && (
        <div className={styles.articleContent} dangerouslySetInnerHTML={{ __html: descriptionHtml || content }}></div>
      )}
    </Layout>
  );
}
